import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function scrollToPageTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });

  const scrollingElement = document.scrollingElement || document.documentElement;
  if (scrollingElement) {
    scrollingElement.scrollTop = 0;
    scrollingElement.scrollLeft = 0;
  }

  if (document.body) {
    document.body.scrollTop = 0;
    document.body.scrollLeft = 0;
  }
}

export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) return undefined;

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    const requestFrame = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 0));
    const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;

    scrollToPageTop();

    const frameId = requestFrame(scrollToPageTop);
    const timeoutIds = [60, 180, 360].map((delay) => window.setTimeout(scrollToPageTop, delay));

    return () => {
      cancelFrame(frameId);
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }, [pathname, search]);

  return null;
}
